import { Component, Input, input, OnInit } from '@angular/core';
import { WebexFieldConfig } from '../../../../shared/models/generated/ziroModels';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { ZiroFormConfig, ZiroFormsValidationState } from '../../../../forms/ziro-forms-models';
import { Observable } from 'rxjs';
import { DidSelectorFormData } from '../did-selector-form/did-selector-form.component';
import { UCM_LICENSE_NAME } from '../webex-calling.component';

export interface ExtensionDetailsEntity {
  extension: string;
}

@Component({
  selector: 'ziro-extension-details-form',
  templateUrl: './extension-details-form.component.html',
  standalone: false,
})
export class ZiroExtensionDetailsFormComponent
  extends ZiroFormAbstractDirective<ExtensionDetailsEntity>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;

  UCM_LICENSE_NAME = UCM_LICENSE_NAME;

  readonly webexFieldConfigV1 = input<WebexFieldConfig>();
  readonly enableWebexPerSite = input<boolean>();
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set didSelectorFormData(newVal: DidSelectorFormData) {
    this._didSelectorFormData = newVal;
    this._setFieldStates();
  }
  get didSelectorFormData(): DidSelectorFormData {
    return this._didSelectorFormData;
  }
  private _didSelectorFormData: DidSelectorFormData;

  formConfig: ZiroFormConfig;

  ngOnInit(): void {
    this._initFormConfig();
  }

  protected submit(): Observable<any> {
    return this.parentSubmit$();
  }

  private _initFormConfig(): void {
    this.formConfig = {
      fields: {
        extension: {
          label: 'tkey;helpdesk.webex_calling.extension_details.extension.label',
          dataAutomation: 'webex-calling-extension',
          required: () => this.webexFieldConfigV1().extension.required || !this.didSelectorFormData.did,
          defaultValue: () => this.webexFieldConfigV1().extension.defaultValue,
          hidden: () => !this.webexFieldConfigV1().extension.show,
          validation: [
            {
              validator: (val) =>
                !val || /^[0-9]{2,10}$/.test(val) ? ZiroFormsValidationState.VALID : ZiroFormsValidationState.INVALID,
              message: 'tkey;helpdesk.webex_calling.extension_details.validation.message',
            },
          ],
          valExcluded: () => this.didSelectorFormData?.webexCallingLicense === UCM_LICENSE_NAME,
        },
      },
    };
  }
}
